import { render } from "./TermTooltip.vue?vue&type=template&id=bf89df32&scoped=true"
import script from "./TermTooltip.vue?vue&type=script&lang=js"
export * from "./TermTooltip.vue?vue&type=script&lang=js"

import "./TermTooltip.vue?vue&type=style&index=0&id=bf89df32&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf89df32"]])

export default __exports__